import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';
import { parseDurationToMinutes } from '../../utils/duration';

// Unused: hardcoded type-30 CRUD. Live workflow calls use workflowStepsEndpoint(id).
// export const WORKFLOW_ENDPOINT = '/api/v1/complaint-types/30/workflow-steps';
export const workflowStepsEndpoint = (id) =>
  `/api/v1/complaint-types/${id}/workflow-steps`;

function apiErrorMessage(error) {
  const data = error?.response?.data ?? error?.payload ?? error;
  const details = Array.isArray(data?.errors)
    ? data.errors.map((item) => item?.message).filter(Boolean)
    : [];
  if (details.length) return details.join(' ');
  return (
    data?.message ??
    data?.error ??
    error?.message ??
    'Something went wrong'
  );
}

function toBooleanFlag(value) {
  if (value === true || value === 'Yes' || value === 'yes' || value === 'true' || value === 1 || value === '1') {
    return true;
  }
  return false;
}

const rejectRequest = (error, thunkApi) =>
  thunkApi.rejectWithValue({
    status: error?.response?.status ?? error?.status,
    message: apiErrorMessage(error),
  });

// Unused: nothing in the app dispatches these. Only fetch/update steps are used.
// export const fetchWorkflowTypes = createAsyncThunk(
//   'workflow/fetchAll',
//   async (_, thunkApi) => {
//     try {
//       const response = await api.get(WORKFLOW_ENDPOINT);
//       return response.data;
//     } catch (error) {
//       return rejectRequest(error, thunkApi);
//     }
//   },
// );

// export const fetchWorkflowById = createAsyncThunk(
//   'workflow/fetchById',
//   async (id, thunkApi) => {
//     try {
//       const response = await api.get(`${WORKFLOW_ENDPOINT}/${id}`);
//       return response.data;
//     } catch (error) {
//       return rejectRequest(error, thunkApi);
//     }
//   },
// );

export const fetchWorkflowSteps = createAsyncThunk(
  'workflow/fetchSteps',
  async (id, thunkApi) => {
    try {
      const response = await api.get(workflowStepsEndpoint(id));
      return response.data;
    } catch (error) {
      return rejectRequest(error, thunkApi);
    }
  },
);

export const updateWorkflowSteps = createAsyncThunk(
  'workflow/updateSteps',
  async ({ id, tables, onSuccess, onFail }, thunkApi) => {
    console.log('tables:', tables);
    console.log('is array:', Array.isArray(tables.tables));

    try {
      if (!Array.isArray(tables.tables)) {
        throw new Error('tables must be an array');
      }

      const steps = tables.tables.map((item, index) => ({
        levelNo: index + 1,
        roleIds: Array.isArray(item.role)
          ? item.role.map((roleId) => Number(roleId))
          : [],
        escalateAfterMinutes: parseDurationToMinutes(item.escalateAfterMinutes),
        canResolve: toBooleanFlag(item.canResolve),
        canReassign: toBooleanFlag(item.canReassign),
        isFinalLevel: toBooleanFlag(item.finalLevel),
        isActive: true,
      }));

      console.log('steps:', steps);

      const response = await api.put(
        workflowStepsEndpoint(id),
        {
          
          steps,
        }
      );

      if (typeof onSuccess === 'function') {
        onSuccess(response.data);
      }

      return response.data;

    } catch (error) {
      if (typeof onFail === 'function') {
        onFail(error);
      }

      return rejectRequest(error, thunkApi);
    }
  }
);

// Unused: complaint types are created via redux/complaintType, not these workflow CRUD thunks.
// export const createWorkflow = createAsyncThunk(
//   'workflow/create',
//  async ({ payload, onSuccess, onFail }, thunkApi) => {
//     try {


//       const data={
//         code:payload.categoryName, 
//         name: payload.categoryName,
//         description: payload.description,
//         tatMinutes: payload.tatMinutes,
//         isActive: payload.active,
//         accessType:"INTERNAL_LOGIN",
//         // accessType: payload.visibilityType,
//       // roleIds: payload.roles.map((role) => parseInt(role, 10)),
//       roleIds:[],
//       }
//       // console.log('createWorkflow payload:', payload ,'api token:', api.defaults.headers.Authorization);
//       const response = await api.post(WORKFLOW_ENDPOINT, data);
//       if(onSuccess && typeof onSuccess === 'function'){
//         onSuccess(response.data);
//       }
//       return response.data;
//     } catch (error) {
//       console.log('createWorkflow error:', error);
//       if(onFail && typeof onFail === 'function'){
//         onFail(error);
//       }
//       return rejectRequest(error, thunkApi);
//     }
//   },
// );

// export const updateWorkflow = createAsyncThunk(
//   'workflow/update',
//   async ({ id, data, onSuccess, onFail  }, thunkApi) => {
//     try {
//       const response = await api.patch(`${WORKFLOW_ENDPOINT}/${id}`, data);
//       if(onSuccess && typeof onSuccess === 'function'){
//         onSuccess(response.data);
//       }
//       return response.data;
//     } catch (error) {
//       console.log('updateWorkflow error:', error);
//       if(onFail && typeof onFail === 'function'){
//         onFail(error);
//       }
//       return rejectRequest(error, thunkApi);
//     }
//   },
// );

// export const deleteWorkflow = createAsyncThunk(
//   'workflow/delete',
//   async (id, thunkApi) => {
//     try {
//       const response = await api.delete(`${WORKFLOW_ENDPOINT}/${id}`);
//       return { id, data: response.data };
//     } catch (error) {
//       return rejectRequest(error, thunkApi);
//     }
//   },
// );
